/* Spam honeypot + time-trap for theme forms. Pairs with snippets/honeypot.liquid.
   Blocks submission client-side (before the POST reaches Shopify) when the hidden
   field is filled, or when the form is submitted implausibly fast (bot behaviour). */
(function () {
  var MIN_SECONDS = 2.5; // submissions faster than this are treated as bots

  function bind(hp) {
    var form = hp.form || (hp.closest && hp.closest('form'));
    if (!form || form.dataset.hpBound) return;
    form.dataset.hpBound = 'true';
    var loadedAt = Date.now();

    form.addEventListener('submit', function (e) {
      var filled = (hp.value || '').trim() !== '';
      var tooFast = (Date.now() - loadedAt) < MIN_SECONDS * 1000;
      if (filled || tooFast) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  }

  function init() {
    var fields = document.querySelectorAll('.js-hp-field');
    for (var i = 0; i < fields.length; i++) bind(fields[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
